// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"wrapper-2Iv7_","wrapper_fullScreen":"wrapper_fullScreen-1ZNjM","loader":"loader-20Qkt","rotation":"rotation-3dadK"};